export default __webpack_public_path__ + "static/media/03.4f47efbc.svg";